import { ListItem } from "../models/ListItem";
import GenericService from "./genericService";
import { httpService } from "./httpService";
import { Tier } from "../models/tier.model";
import { PagedResultDTO } from "../models/pagedResultDto.model";

class TierService extends GenericService<Tier, ListItem> {
    constructor() {
        super('/api/Tier');
    }
}

export const tierService = new TierService();